import { DataService } from './dataService'

export const reportService = {
    getPerformanceReort: async (data) => {
        return DataService.get('/admin/report/performance', data)
    },
    exportPerformanceReort: async (data) => {
        return DataService.get('/admin/report/export/performance', data)
    },

    getRetailerPurchaseInvoice: async (data) => {
        return DataService.get('/admin/report/purchaseInvoice', data)
    },
    exportRetailerPurchaseInvoice: async (data) => {
        return DataService.get('/admin/report/export/purchaseInvoice', data)
    },

    getAddOns: async (data) => {
        return DataService.get('/admin/report/addOns', data)
    },
    exportAddOns: async (data) => {
        return DataService.get('/admin/report/export/addOns', data)
    },

    getVendorReport: async (data) => {
        return DataService.get('/admin/report/vendors', data)
    },
    exportVendors: async (data) => {
        return DataService.get('/admin/report/export/vendors', data)
    },

    getCustomerService: async (data) => {
        return DataService.get('/admin/report/customerService', data)
    },
    exportCustomerService: async (data) => {
        return DataService.get('/admin/report/export/customerService', data)
    },

    getSalesTele: async (data) => {
        return DataService.get('/admin/report/salesTele', data)
    },
    exportSalesTele: async (data) => {
        return DataService.get('/admin/report/export/salesTele', data)
    },
    exportTrackingReport: async (data) => {
        return DataService.get('/admin/report/export/get_tracking', data)
    },
    // exportTrackingReport: async (data) => {
    //     return DataService.get('/admin/export/get_tracking', data)
    // },
    exportFinancialcloseReport: async (data) => {
        return DataService.get('/admin/export/get_financial_report', data)
    },
    getInvoiceReport: async (data) => {
        return DataService.get('/admin/report/invoice_date_wise', data)
    },
    invoiceReportexcel: async (data) => {
        return DataService.get('/admin/report/export/invoice_date_wise', data)
    },
    getCustomerReport: async (data) => {
        return DataService.get('/admin/report/customer-report', data)
    },
    customerReportexcel: async (data) => {
        return DataService.get('/admin/report/export/customer-report', data)
    },
    // invoiceReortexcel: async (data) => {
    //     return DataService.get('/admin/report/export/performance', data)
    // },

}